import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
class PostWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    let hrefDefault = "";
    return (
      <section className="single-blog-wrap section-padding">
        <div className="container">
          <div className="row gx-5">
            <div className="col-xl-9 col-lg-8">
              <article>
                <div className="section-title v1 mb-4">
                  <h2>How to support your immune system</h2>
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                  ipsum dolor sit amet, consetetur sadipscing elitr.
                </p>
                <blockquote className="wp-block-quote">
                  <p>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                    diam nonumy eirmod tempor invidunt ut labore et dolore magna
                    aliquyam erat, sed diam voluptua. At vero eos et accusam et
                    justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                    sea takimata sanctus est Lorem ipsum dolor sit amet.
                  </p>
                </blockquote>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                  ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                  nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                  ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                  nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                  ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                  nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet.
                </p>
                <div className="post-img">
                  <img
                    src="/static/images/blog/blog-10.png"
                    alt="none"
                    className="img-fluid"
                  />
                </div>
                <p>
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                  ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                  nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                  ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                  nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem
                  ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
                  nonumy eirmod tempor invidunt ut labore et dolore magna
                  aliquyam erat, sed diam voluptua. At vero eos et accusam et
                  justo duo dolores et ea rebum. Stet clita kasd gubergren, no
                  sea takimata sanctus est Lorem ipsum dolor sit amet.
                </p>
              </article>
              <div className="comment-box-wrap">
                <div className="comment-box-title">
                  <div className="comment-box-title-left">
                    <p>2 More Comments</p>
                  </div>
                  <div className="comment-box-title-left">
                    <a href={hrefDefault.toString()}>Leave Your Comment</a>
                  </div>
                </div>
                <div className="comment-box approved">
                  <div className="comment-author">
                    <div className="row align-items-center">
                      <div className="col-lg-7 col-md-8">
                        <div className="comment-author-info">
                          <div className="ct_author_avatar">
                            <img
                              src="/static/images/blog/avatar-2.png"
                              alt="none"
                            />
                            <p>Kaitlin R. Rios</p>
                          </div>
                          <div className="comment-rating">
                            <ul className="product-rating">
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 col-md-4">
                        <div className="comment-date">
                          <p>6:41 AM, 30 January, 2024</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="comment-text">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Dolores ullam debitis quo atque quidem harum quisquam,
                    minima, ad ab, nam neque voluptatum commodi eveniet! Laborum
                    voluptatibus minima doloremque sint odit, amet voluptate
                    nobis ullam, nostrum sunt deleniti cumque dolorem sequi
                    necessitatibus obcaecati, quaerat quibusdam, qui dignissimos
                    sit? Quaerat, iure pariatur.
                  </div>
                  <div className="reply-comment">
                    <Link to={hrefDefault.toString()} className="btn v13">
                      Reply
                    </Link>
                  </div>
                </div>
                <div className="comment-box declined">
                  <div className="comment-author">
                    <div className="row  align-items-center">
                      <div className="col-lg-7 col-md-8">
                        <div className="comment-author-info">
                          <div className="ct_author_avatar">
                            <img
                              src="/static/images/blog/avatar-1.png"
                              alt="none"
                            />
                            <p>Jennifer D. Mitchell</p>
                          </div>
                          <div className="comment-rating">
                            <ul className="product-rating">
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                              <li>
                                <i className="flaticon-star" />
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 col-md-4">
                        <div className="comment-date">
                          <p>6:41 AM, 30 January, 2024</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="comment-text">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Dolores ullam debitis quo atque quidem harum quisquam,
                    minima, ad ab, nam neque voluptatum commodi eveniet! Laborum
                    voluptatibus minima doloremque sint odit, amet voluptate
                    nobis ullam, nostrum sunt deleniti cumque dolorem sequi
                    necessitatibus obcaecati, quaerat quibusdam, qui dignissimos
                    sit? Quaerat, iure pariatur.
                  </div>
                  <div className="reply-comment">
                    <Link to={hrefDefault.toString()} className="btn v13">
                      Reply
                    </Link>
                  </div>
                </div>
                <div id="cmt_form" className="comment_form">
                  <h3 className="comment-form-title">Leave Your Comment</h3>
                  <form action="#">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="msg">Comments</label>
                          <textarea
                            name="msg"
                            id="msg"
                            cols={30}
                            rows={10}
                            defaultValue={""}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="name">Name*</label>
                          <input
                            name="name"
                            id="name"
                            type="text"
                            required=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="email">Email*</label>
                          <input
                            name="email"
                            id="email"
                            type="text"
                            required=""
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="check_box mb-20">
                          <input type="checkbox" id="test_100" />
                          <label htmlFor="test_100">
                            Save my information for the next time I comment.
                          </label>
                        </div>
                        <button type="submit" className="btn v14">
                          Post A Comment
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4">
              <div className="sidebar">
                <div className="sidebar-widget search-box">
                  <input type="search" placeholder="Search By Keywords" />
                  <button type="submit">
                    <i className="flaticon-search-interface-symbol" />
                  </button>
                </div>
                <div className="sidebar-widget popular-post">
                  <h4 className="sidebar-widget-title">Popular Posts</h4>
                  <div className="popular-post-item">
                    <div className="post-img">
                      <img
                        src="/static/images/blog/post-thumb-1.png"
                        alt="none"
                      />
                    </div>
                    <div className="post-info">
                      <span>08 Jan, 2024</span>
                      <h5>
                        <Link to={hrefDefault.toString()} className="btn v13">
                          How To Clean Cardio Machines, Including Treadmill.
                        </Link>
                      </h5>
                    </div>
                  </div>
                  <div className="popular-post-item">
                    <div className="post-img">
                      <img
                        src="/static/images/blog/post-thumb-1.png"
                        alt="none"
                      />
                    </div>
                    <div className="post-info">
                      <span>09 Jan, 2024</span>
                      <h5>
                        <Link to={hrefDefault.toString()}>
                          6 Healthy Habits You Should Try This Year
                        </Link>
                      </h5>
                    </div>
                  </div>
                  <div className="popular-post-item">
                    <div className="post-img">
                      <img
                        src="/static/images/blog/post-thumb-1.png"
                        alt="none"
                      />
                    </div>
                    <div className="post-info">
                      <span>10 Jan, 2024</span>
                      <h5>
                        <Link to={hrefDefault.toString()}>
                          6 Tips For Improving Sports Performance
                        </Link>
                      </h5>
                    </div>
                  </div>
                  <div className="popular-post-item">
                    <div className="post-img">
                      <img
                        src="/static/images/blog/post-thumb-1.png"
                        alt="none"
                      />
                    </div>
                    <div className="post-info">
                      <span>11 Jan, 2024</span>
                      <h5>
                        <Link to={hrefDefault.toString()}>
                          Exercise And Face Coverings: What Does The Research
                          Say?
                        </Link>
                      </h5>
                    </div>
                  </div>
                </div>
                <div className="sidebar-widget category-list">
                  <h4 className="sidebar-widget-title">Popular Categories</h4>
                  <div className="category-box">
                    <ul>
                      <li>
                        <Link to={hrefDefault.toString()}>
                          Fitness Facts Say?
                        </Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Group Exercise</Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>
                          Lifestyle Medicine
                        </Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Nutrition</Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>
                          Strength Training
                        </Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Women's Health</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="sidebar-widget tags">
                  <h4 className="sidebar-widget-title">Popular Tags</h4>
                  <div className="tag-list">
                    <ul>
                      <li>
                        <Link to={hrefDefault.toString()}>Fitness</Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Facts</Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Medicine</Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Lifestyle</Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Strength</Link>
                      </li>
                      <li>
                        <Link to={hrefDefault.toString()}>Women's Health</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = () => ({});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PostWrapper)
);
